// extracted by mini-css-extract-plugin
export default {"section":"style_section__9QPS+"};